<div class="accommodations-container">
    <div class="content-wrapper">

        <!-- Header (Legal Style) -->
        <h1 class="title">{{'ACCOMMODATIONS.TITLE' | translate}}</h1>
        <hr class="separator-line">

        @if (loaded) {
        <!-- Description Sections -->
        <div class="intro-sections">
            <div class="intro-block">
                <p>{{'ACCOMMODATIONS.INTRO_1' | translate}}</p>
                <div class="intro-image-container">
                    <img src="assets/images/wonders/accommodation1.jpg" [alt]="'ACCOMMODATIONS.INTRO_1_ALT' | translate"
                        class="intro-image">
                </div>
            </div>

            <div class="intro-block">
                <p>{{'ACCOMMODATIONS.INTRO_2' | translate}}</p>
                <div class="intro-image-container">
                    <img src="assets/images/wonders/accommodation2.jpg" [alt]="'ACCOMMODATIONS.INTRO_2_ALT' | translate"
                        class="intro-image">
                </div>
            </div>

            <div class="intro-block">
                <p>{{'ACCOMMODATIONS.INTRO_3' | translate}}</p>
                <div class="intro-image-container">
                    <img src="assets/images/wonders/accommodation3.jpg" [alt]="'ACCOMMODATIONS.INTRO_3_ALT' | translate"
                        class="intro-image">
                </div>
            </div>
        </div>

        <!-- Accordion -->
        <div class="accordion-container">
            @for (pueblo of pueblosList; track pueblo) {

            @if (accommodationsByPueblo[pueblo] && accommodationsByPueblo[pueblo].length > 0) {
            <div class="accordion-section">
                <!-- Accordion Header -->
                <button class="accordion-header" (click)="toggleLocation(pueblo)"
                    [class.expanded]="expandedLocations[pueblo]">
                    <span class="accordion-title">{{ pueblo }}</span>
                    <span class="accordion-count">({{ accommodationsByPueblo[pueblo].length }})</span>
                    <span class="accordion-chevron">▼</span>
                </button>

                <!-- Accordion Body -->
                <div class="accordion-body" [class.visible]="expandedLocations[pueblo]">
                    <div class="cards-grid">
                        @for (feature of accommodationsByPueblo[pueblo]; track feature.id) {
                        <div class="accommodation-card">
                            @if (feature.properties.tipologia) {
                            <span class="card-badge">{{ feature.properties.tipologia }}</span>
                            }
                            <h3 class="card-title">{{ feature.properties.denominacion }}</h3>
                            @if (feature.properties.enlace_maps) {
                            <a [href]="extractMapsUrl(feature.properties.enlace_maps)" target="_blank" rel="noopener noreferrer"
                                class="maps-button">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                    <circle cx="12" cy="10" r="3"></circle>
                                </svg>
                                {{'ACCOMMODATIONS.VIEW_MAPS' | translate}}
                            </a>
                            }
                        </div>
                        }
                    </div>
                </div>
            </div>
            }

            }
        </div>
        } @else {
        <!-- Loading State -->
        <div style="text-align: center; padding: 3rem; color: #888;">
            <div class="loading-spinner"></div>
            <p>{{'ACCOMMODATIONS.LOADING' | translate}}</p>
        </div>
        }
    </div>
</div>